import React from 'react';
import { DrawApi } from '@apply/api';
import { DrawAutomaticBorrowerColumn } from './DrawAutomaticBorrowerColumn';
import { DrawAutomaticColumn } from './DrawAutomaticColumn';
import { DrawManualBorrowerColumn } from './DrawManualBorrowerColumn';
import { DrawManualColumn } from './DrawManualColumn';
import { DrawType } from '@apply/constants';
import { Dispatch, ReactElement, SetStateAction } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { DrawManualInspectionColumn } from './DrawManualInspectionColumn';

interface IDrawColumnProps {
    drawId: number;
    drawNumber: number;
    drawType: DrawType;
    drawFinalized: boolean;
    latestDrawHasFunding: boolean;
    hasResubmitted: boolean;
    needsBorrowerSignature: boolean;
    isInspectionRequireFirst: boolean;
    borrowerSubmitted: boolean;
    fundedOn: Date;
    toggleArray: boolean[];
    applicationInsights: ApplicationInsights;
    isAdmin: boolean;
    set_drawBudget: Dispatch<SetStateAction<DrawApi.IDrawBudget | undefined>>;
    set_isSnackbarOpen: (isSnackbarOpen: boolean) => void;
    set_snackbarMessage: (snackbarMessage: string) => void;
    set_isLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DrawColumn = ({
    drawId,
    drawNumber,
    drawType,
    drawFinalized,
    latestDrawHasFunding,
    hasResubmitted,
    needsBorrowerSignature,
    isInspectionRequireFirst,
    borrowerSubmitted,
    fundedOn,
    toggleArray,
    applicationInsights,
    set_drawBudget,
    set_isSnackbarOpen,
    set_snackbarMessage,
    set_isLoading,
    isAdmin,
}: IDrawColumnProps): ReactElement[][] => {
    const AdminColumn = () => {
        switch (drawType) {
            case DrawType.Automatic:
                return [
                    DrawAutomaticColumn({
                        drawId,
                        drawNumber,
                        drawFinalized,
                        toggleArray,
                        applicationInsights,
                        set_drawBudget,
                        set_isLoading,
                    }),
                ];
            case DrawType.Manual:
                if (isInspectionRequireFirst) {
                    return [
                        DrawManualInspectionColumn({
                            drawId,
                            drawNumber,
                            drawFinalized,
                            latestDrawHasFunding,
                            toggleArray,
                            applicationInsights,
                            set_drawBudget,
                            set_isLoading,
                        }),
                    ];
                } else {
                    return [
                        DrawManualColumn({
                            drawId,
                            drawNumber,
                            drawFinalized,
                            latestDrawHasFunding,
                            toggleArray,
                            applicationInsights,
                            set_drawBudget,
                        }),
                    ];
                }
            default:
                return [[<div>Error loading draw columns</div>]];
        }
    };

    const BorrowerColumn = () => {
        switch (drawType) {
            case DrawType.Automatic:
                return [
                    DrawAutomaticBorrowerColumn({
                        drawId,
                        drawNumber,
                        fundedOn,
                        drawFinalized,
                    }),
                ];
            case DrawType.Manual:
                return [
                    DrawManualBorrowerColumn({
                        drawId,
                        drawNumber,
                        drawFinalized,
                        needsBorrowerSignature,
                        borrowerSubmitted,
                        hasResubmitted,
                        fundedOn,
                        set_isSnackbarOpen,
                        set_snackbarMessage,
                    }),
                ];
            default:
                return [[<div>Error loading draw columns</div>]];
        }
    };

    if (isAdmin) {
        return AdminColumn();
    } else {
        return BorrowerColumn();
    }
};
